import { Component, Input, OnInit } from '@angular/core';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { DataPointsResult } from '../../../interfaces/data-points';
import { Observable } from 'rxjs';
import { AppModel } from '@ams/dumbledore';
import { Installation } from '../../../interfaces/facilty';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { HeatMeterStatusTileComponent } from '../../heat-meter-status-tile/heat-meter-status-tile.component';
import { ForwardReturnChartTileComponent } from '../../charts/forward-return-chart-tile/forward-return-chart-tile.component';
import { FlowHeatMeterChartTileComponent } from '../../charts/flow-heat-meter-chart-tile/flow-heat-meter-chart-tile.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-district-heating-dashboard',
    templateUrl: './district-heating-dashboard.component.html',
    styleUrls: ['./district-heating-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    HeatMeterStatusTileComponent,
    ForwardReturnChartTileComponent,
    FlowHeatMeterChartTileComponent,
    TranslateModule,
    AsyncPipe
]
})
export class DistrictHeatingDashboardComponent {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() public application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;
}
